/**
 * Extracts a human-readable error message from an RTK Query error.
 * The backend returns { code: string, message: string } in error responses.
 *
 * Extraction priority:
 * 1. `data.message` — the human-readable message from the backend
 * 2. `data.error` — fallback error field
 * 3. Generic fallback string
 */
export function extractApiErrorMessage(err: unknown): string {
    if (err && typeof err === 'object') {
        const data = (err as Record<string, unknown>).data;
        if (data && typeof data === 'object') {
            const d = data as Record<string, unknown>;
            if (typeof d.message === 'string') return d.message;
            if (typeof d.error === 'string') return d.error;
        }
    }
    return 'Failed to send message. Please try again.';
}
